import { ReactComponent as IconSearchComponent } from "./svg/icon_search.svg";

type Props = {
  width?: string;
  height?: string;
  marginTop?: string;
};

export const IconSearch = ({ width, height, marginTop }: Props) => {
  return <IconSearchComponent style={{ width, height, marginTop }} />;
};
